import React, { Component } from "react";
import { withRouter } from "react-router";
import CreateOffer from "./CreateOffer";

class MiniOffer extends Component {
	constructor() {
		super();
		this.state = {};
	}

	componentDidMount() {}

	render() {
		return (
			<div className="offers-row row no-margin">
				<div className="col-xs-16 no-padding col-md-8 col-md-offset-4">
					<CreateOffer isIframe={true} dedicatedOffer={true} />
				</div>
			</div>
		);
	}
}

export default withRouter(MiniOffer);
